export default __webpack_public_path__ + "static/media/logoBiblicalGreek.9a83a984.png";